import { WizardStep } from '@app/wizard-bar/services/wizard.service';

export class QuickQuoteConstants {
  public static wizardSteps: WizardStep[] = [
    { name: 'Quote Configuration', svg: 'tender-settings', slug: 'quote-configuration' },
    { name: 'Get Quote', svg: 'icon-quote', slug: 'get-quote' },
  ];
}
